import * as api from "services/api";

export const GET_FINANCIAL_ACCOUNTS =
  "[FINANCIAL ACCOUNT] GET_FINANCIAL_ACCOUNTS";
export const GET_FINANCIAL_ACCOUNTS_FAILED =
  "[FINANCIAL ACCOUNT] GET_FINANCIAL_ACCOUNTS_FAILED";
export const GET_FINANCIAL_ACCOUNTS_SUCCESS =
  "[FINANCIAL ACCOUNT] GET_FINANCIAL_ACCOUNTS_SUCCESS";

export const SET_VALUE = "[FINANCIAL ACCOUNT] SET_VALUE";
export const CLEAR_VALUE = "[FINANCIAL ACCOUNT] CLEAR_VALUE";

export function getFinancialAccounts() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_FINANCIAL_ACCOUNTS
    });

    const { token } = getState().login;

    let response = await api.sendGet("/FinancialAccount", {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      dispatch({
        type: GET_FINANCIAL_ACCOUNTS_SUCCESS,
        payload: json.model
      });
    } else {
      dispatch({ type: GET_FINANCIAL_ACCOUNTS_FAILED });
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}
